"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandServicesConfiguration = exports.BSCJobTypeEnum = void 0;
const typeorm_1 = require("typeorm/browser");
const service_1 = require("./service");
const invoicing_target_1 = require("./invoicing-target");
const opportunity_1 = require("./opportunity");
const account_1 = require("./account");
var BSCJobTypeEnum;
(function (BSCJobTypeEnum) {
    BSCJobTypeEnum["LIVE"] = "live";
    BSCJobTypeEnum["PROPOSAL"] = "proposal";
})(BSCJobTypeEnum = exports.BSCJobTypeEnum || (exports.BSCJobTypeEnum = {}));
let BrandServicesConfiguration = class BrandServicesConfiguration {
};
BrandServicesConfiguration.SFID_PREFIX = 'a2H';
BrandServicesConfiguration.NAME_PREFIX = 'BSC';
__decorate([
    (0, typeorm_1.PrimaryColumn)({
        type: 'character varying',
        length: 18,
        name: 'sfid',
        default: () => "gid_generate_sfid('a2H')",
    }),
    __metadata("design:type", String)
], BrandServicesConfiguration.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 255,
        name: 'api_id__c',
    }),
    __metadata("design:type", String)
], BrandServicesConfiguration.prototype, "apiId", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        nullable: false,
        name: 'name',
        length: 80,
        default: () => "gid_generate_name('BSC', 6)",
    }),
    __metadata("design:type", String)
], BrandServicesConfiguration.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 255,
        name: 'brand_service_id__c',
        nullable: true,
    }),
    __metadata("design:type", String)
], BrandServicesConfiguration.prototype, "brandServiceId", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 18,
        name: 'product2__c',
        nullable: true,
    }),
    __metadata("design:type", String)
], BrandServicesConfiguration.prototype, "product2Id", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'double precision',
        name: 'service_quantity__c',
        nullable: true,
    }),
    __metadata("design:type", Number)
], BrandServicesConfiguration.prototype, "serviceQuantity", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: BSCJobTypeEnum,
        name: 'job_type__c',
        nullable: true,
    }),
    __metadata("design:type", String)
], BrandServicesConfiguration.prototype, "jobType", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        nullable: false,
        enum: invoicing_target_1.InvoicingTargetEnum,
        name: 'invoicing_target__c',
    }),
    __metadata("design:type", String)
], BrandServicesConfiguration.prototype, "invoicingTarget", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: 'createddate',
    }),
    __metadata("design:type", Date)
], BrandServicesConfiguration.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: 'lastmodifieddate',
    }),
    __metadata("design:type", Date)
], BrandServicesConfiguration.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => service_1.Service, (services) => services.rejectedServices, {
        nullable: false,
    }),
    (0, typeorm_1.JoinColumn)({ name: 'service__c' }),
    __metadata("design:type", service_1.Service)
], BrandServicesConfiguration.prototype, "service", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_1.Opportunity, { nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: 'opportunity__c' }),
    __metadata("design:type", opportunity_1.Opportunity)
], BrandServicesConfiguration.prototype, "opportunity", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => account_1.Account, { nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: 'brand__c' }),
    __metadata("design:type", account_1.Account)
], BrandServicesConfiguration.prototype, "brand", void 0);
BrandServicesConfiguration = __decorate([
    (0, typeorm_1.Entity)('brand_services_configuration__c', {
        schema: 'public',
        synchronize: false,
    })
], BrandServicesConfiguration);
exports.BrandServicesConfiguration = BrandServicesConfiguration;
//# sourceMappingURL=brand-services-configuration.js.map